import { bunja } from 'bunja';
import { addHours, isAfter, parseISO } from 'date-fns';
import { atom } from 'jotai';
import { atomWithMutation, atomWithQuery } from 'jotai-tanstack-query';

import { postAgreementApi } from '@flipster/apis/v1/agreement';
import { AgreementType } from '@flipster/apis/v1/agreement/types';
import { getCurrentKYCStatusApi } from '@flipster/apis/v1/kyc';
import { authBunja } from '@flipster/features/src/shared/auth/state';
import { overlayBunja } from '@flipster/overlay';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getFlipsterConfigsV1Key, getLocalStorage } from '@flipster/utils/localStorage';
import { TncTransitionFromRoute } from '@flipster/utils/segment';

import { VaraTransitionAgreementModal } from '.';

export const varaTransitionAgreementBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const overlay = bunja.use(overlayBunja);
  const { isCookieLoggedInAtom } = bunja.use(authBunja);
  const getKYCStatusApiAtom = atomWithQuery((get) => {
    const isCookieLoggedIn = get(isCookieLoggedInAtom);

    return {
      queryKey: ['getCurrentKYCStatusApi', 'withBunja'],
      queryFn: getCurrentKYCStatusApi,
      enabled: isCookieLoggedIn,
    };
  });

  const isTncAgreementRequiredAtom = atom((get) => get(getKYCStatusApiAtom).data?.data.tncAgreementRequired);

  const postTncAgreementApiAtom = atomWithMutation(() => ({
    mutationKey: ['postAgreementApi'],
    mutationFn: (agreementType: AgreementType) => postAgreementApi({ agree: agreementType }),
  }));

  async function checkTncAgreementModalNeedToShow(userId: number) {
    const { data } = await store.get(getKYCStatusApiAtom).refetch();
    const isTncAgreementRequired = data?.data.tncAgreementRequired;
    const key = getFlipsterConfigsV1Key(userId, 'tncAgreementModalHideTimestamp');
    const hideTimeStamp = getLocalStorage(key);

    if (!isTncAgreementRequired) return false;
    if (hideTimeStamp) {
      const nextShowTime = addHours(parseISO(hideTimeStamp), 24);
      const currentTime = new Date();

      return isAfter(currentTime, nextShowTime);
    }

    return true;
  }

  function openTncAgreementModal(param?: { from?: TncTransitionFromRoute }) {
    overlay.open(() => <VaraTransitionAgreementModal from={param?.from} />);
  }

  return {
    isTncAgreementRequiredAtom,
    postTncAgreementApiAtom,
    checkTncAgreementModalNeedToShow,
    openTncAgreementModal,
  };
});

varaTransitionAgreementBunja.debugLabel = 'varaTransitionAgreementBunja';
